import type {Builder} from '@wix/document-services-types'
import type {PresetsWithVariables} from '../types'
import type {IPresetsRepository} from './repository'
import type {IPresetsManifestProcessor} from './processor'
import type {IPresetsDataTransformer} from './data-transformer'

export interface IPresetsService {
    getPresetsManifest(presets?: string[]): Builder.Presets
}

export class PresetsService implements IPresetsService {
    constructor(
        private readonly presetsRepository: IPresetsRepository,
        private readonly presetsManifestProcessor: IPresetsManifestProcessor,
        private readonly presetsDataTransformer: IPresetsDataTransformer
    ) {}

    getPresetsManifest(presets: string[] = []): Builder.Presets {
        const normalizedPresets = this.getNormalizedPresets()
        return this.presetsManifestProcessor.processPresetsManifest(presets, normalizedPresets)
    }

    private getNormalizedPresets(): PresetsWithVariables {
        const rawData = this.presetsRepository.getRawVariablesData()

        if (!rawData) {
            return {}
        }

        return this.presetsDataTransformer.normalizePresetsData(rawData)
    }
}
